import React from 'react';
import { Button, useTheme } from '@material-ui/core';
import { useStyles } from './styles';
import { IRouterProps } from 'pages/orderHistory';
import { useAnswerFormContext } from '../context';

export const Footer = ({ router }: IRouterProps) => {
  const theme = useTheme();
  const { previewFooter } = useStyles(theme);

  const { handleSubmitAnswers, isSubmitDataLoading } = useAnswerFormContext();

  const handleRedirectToForms = () => {
    router.push('formularios');
  };

  return (
    <div className={previewFooter}>
      <Button onClick={handleSubmitAnswers} variant="contained" color="primary" disabled={isSubmitDataLoading}>
        Salvar Respostas
      </Button>
      <Button onClick={handleRedirectToForms} variant="outlined" color="primary">
        Voltar
      </Button>
    </div>
  );
};
